// extracted by mini-css-extract-plugin
export default {"hero":"responsiveStyles_hero__Lz4AN","heroContent":"responsiveStyles_heroContent__ywz6g","tagLine":"responsiveStyles_tagLine__GBcoI"};